/* ============================================================================
   NEOGEN — MOTION infrastructure  (real + usable)
   ----------------------------------------------------------------------------
   Staged 2026-07-07 (Fable 5). Target repo path: assets/neogen-motion.js
   SONNET-LIQUID-BACKLOG: §A cross-cutting motion infrastructure (build once).

   Responsibilities:
     • motionAllowed() — the single launch gate. Motion runs ONLY when NONE of:
         - prefers-reduced-motion: reduce
         - viewport < 768px (mobile ships stills, per launch strategy §11)
         - Save-Data header (navigator.connection.saveData)
         - effectiveType 2g / slow-2g
     • Lazy, play-ONCE <video> hydration: poster-first, source injected on
       intersect, single play, poster-fallback-on-error.
     • Section-reveal IntersectionObserver (adds .is-revealed) shared by every
       surface. Trinity staged reveal is pure CSS off the same .is-revealed.

   Contract:
     <video class="texture-video" data-motion-slot poster="…" width height
            playsinline muted preload="none">
        <source data-src="…webm" type="video/webm">
        <source data-src="…mp4"  type="video/mp4">
     </video>
     Reveal targets: any element with class .reveal (or the section roots the
     mockups already tag: .mission,.flagship,.formula,.ritual,.science,.founder,
     .trinity,.footer). Founder keyframes ship DISABLED (see neogen-motion.css).
   ============================================================================ */
(function () {
  'use strict';

  function motionAllowed() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      if (window.matchMedia('(max-width: 767px)').matches) return false;
      var c = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
      if (c) {
        if (c.saveData) return false;
        if (/(^|-)2g$/.test(c.effectiveType || '')) return false;
      }
    } catch (e) { /* if the checks throw, fail safe → stills */ return false; }
    return true;
  }
  window.neogenMotionAllowed = motionAllowed;

  /* ---- Section reveal IO (always on; independent of video motion) ------ */
  var revealTargets = document.querySelectorAll('.reveal, .trinity');
  var prm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);
  if (!revealTargets.length) { /* nothing to reveal */ }
  else if (prm || !('IntersectionObserver' in window) || designMode) {
    // Reduced motion / no IO → reveal everything immediately (no animation).
    revealTargets.forEach(function (el) { el.classList.add('is-revealed'); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      var sectionRoot = el.closest('.shopify-section') || document.body;
      if (typeof sectionRoot.__neogenRevealIndex !== 'number') sectionRoot.__neogenRevealIndex = 0;
      el.style.setProperty('--reveal-i', Math.min(sectionRoot.__neogenRevealIndex, 4));
      sectionRoot.__neogenRevealIndex += 1;
    });

    var revObs = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealTargets.forEach(function (el) { revObs.observe(el); });

    setTimeout(function () {
      revealTargets.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add('is-revealed');
          revObs.unobserve(el);
        }
      });
    }, 80);
  }

  /* ---- Lazy, play-once video hydration --------------------------------- */
  var videos = document.querySelectorAll('.texture-video[data-motion-slot], video[data-motion-slot]');
  if (!videos.length) return;

  if (!motionAllowed() || !('IntersectionObserver' in window)) {
    // Stills-only: leave posters in place, never inject sources.
    return;
  }

  function hydrate(video) {
    if (video.dataset.motionHydrated) return;
    video.dataset.motionHydrated = '1';
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (s) { s.src = s.getAttribute('data-src'); });
    video.load();
    video.addEventListener('error', function () { video.removeAttribute('src'); /* poster stays */ }, { once: true });
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked → poster stays */ });
    // Play-once: pause on end so it doesn't loop unless data-loop is set.
    if (!video.hasAttribute('data-loop')) {
      video.addEventListener('ended', function () { video.pause(); }, { once: true });
    }
  }

  var vidObs = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { hydrate(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.25 });
  videos.forEach(function (v) { vidObs.observe(v); });
})();
